import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {MerchantListComponent} from './merchant-list.component';
import * as $ from 'jquery';
import {MerchantsService} from './merchants-service';
import {Router} from '@angular/router';
import {HttpErrorValidator} from '../services/http-error-validator';
import {IResultados} from './IMerchant';

@Component({
  selector: 'pm-add-merchant',
  templateUrl: './add-merchant.component.html',
  styleUrls: ['./add-merchant.component.sass']
})
export class AddMerchantComponent implements OnInit, OnDestroy, AfterViewInit {
  isLinear = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  ownershipTypes: IResultados[] = [];
  mcc: IResultados[] = [];
  estadosDeComercio: IResultados[] = [];
  estadosDeComercioDetail: IResultados[] = [];
  monedas: IResultados[] = [];
  paises: IResultados[] = [];
  estadosPaisComercio: IResultados[] = [];
  estadosPaisPropietario: IResultados[] = [];
  estadosPaisFirmante: IResultados[] = [];

  // tslint:disable-next-line:variable-name
  constructor(private _formBuilder: FormBuilder, private parent: MerchantListComponent, public merchantService: MerchantsService,
              private router: Router, private httpErrorValidator: HttpErrorValidator) {
  }

  ngOnInit() {
    this.resetForm();
    this.tipoPropietario();
    this.getMCC();
    this.getEstadosComercio();
    this.getDetalleEstadosComercio();
    this.getCurrencies();
    this.getPaises();
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
  }

  tipoPropietario(): void {
    this.merchantService.getOwnershiptypes().subscribe(response => {
      this.ownershipTypes = response;
    }, err => this.httpErrorValidator.validateError(err));
  }

  getMCC(): void {
    this.merchantService.getMCC().subscribe(response => {
      this.mcc = response;
    }, err => this.httpErrorValidator.validateError(err));
  }

  getEstadosComercio(): void {
    this.merchantService.getSellerstatus().subscribe(response => {
      this.estadosDeComercio = response;
    }, err => this.httpErrorValidator.validateError(err));
  }

  getEstadosPaisComercio(): void {
    this.merchantService.getEstadosPais(this.merchantService.formData.seller.sellerStreetAddress.countryCode).subscribe(response => {
      this.estadosPaisComercio = response;
    }, err => this.httpErrorValidator.validateError(err));
  }

  getEstadosPaisPropietario(): void {
    this.merchantService.getEstadosPais(this.merchantService.formData.significantOwner.streetAddress.countryCode).subscribe(response => {
      this.estadosPaisPropietario = response;
    }, err => this.httpErrorValidator.validateError(err));
  }

  getEstadosPaisFirmante(): void {
    this.merchantService.getEstadosPais(this.merchantService.formData.significantOwner.streetAddress.countryCode).subscribe(response => {
      this.estadosPaisFirmante = response;
    }, err => this.httpErrorValidator.validateError(err));
  }

  getDetalleEstadosComercio(): void {
    this.merchantService.getSellerstatusDetail().subscribe(response => {
      this.estadosDeComercioDetail = response;
    }, err => this.httpErrorValidator.validateError(err));
  }

  getCurrencies(): void {
    this.merchantService.getCurrencies().subscribe(response => {
      this.monedas = response;
    }, err => this.httpErrorValidator.validateError(err));
  }

  getPaises(): void {
    this.merchantService.getCountries().subscribe(response => {
      this.paises = response;
      this.getEstadosPaisComercio();
      this.getEstadosPaisPropietario();
      this.getEstadosPaisFirmante();
      this.merchantService.formData.seller.sellerStreetAddress.regionCode = 'AGU';
      this.merchantService.formData.significantOwner.streetAddress.regionCode = 'AGU';
      this.merchantService.formData.authorizedSigner.streetAddress.regionCode = 'AGU';
    }, err => this.httpErrorValidator.validateError(err));
  }

  cancelarComercio(): void {
    this.parent.showComercios = true;
    this.parent.showAddComercios = false;
  }

  ngOnDestroy() {
    $('a[rel=comercios]').removeClass('selected');
  }

  ngAfterViewInit() {
    $('a[rel=comercios]').addClass('selected');
  }

  addComercio(form: NgForm): void {
    if (form.invalid) {
      Object.values(form.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }
    this.merchantService.addComercio().subscribe(
      res => {
        const setupErrors = this.merchantService.getSetupErrors(res);

        if (setupErrors.length > 0) {
          alert('No se dio de alta el comercio:\n\n' + setupErrors.join('\n'));
          return;
        }

        this.parent.showComercios = true;
        this.parent.showAddComercios = false;
        this.router.navigate(['/comercios']);
      },
      err => {
        this.httpErrorValidator.reportError(err, 'No se dio de alta el comercio');
      }
    );
  }

  resetForm(form?: NgForm) {
    if (form != null) {
      form.resetForm();
    }
    this.merchantService.formData = {
      authorizedSigner: {
        dateOfBirth: '',
        firstName: '',
        lastName: '',
        streetAddress: {
          addressLine1: '',
          addressLine2: '',
          addressLine3: '',
          cityName: '',
          countryCode: 'MX',
          postalCode: '',
          regionCode: ''
        },
        title: ''
      },
      createdAt: '',
      id: 0,
      ownershipType: 'CorporationPrivate',
      requestId: 'null',
      seDetailStatusCode: 'NONE',
      seller: {
        sellerBusinessPhoneNumber: '',
        sellerBusinessRegistrationNumber: '',
        sellerCurrencyCode: 'MXN',
        sellerDbaName: '',
        sellerEmailAddress: '',
        sellerId: '',
        sellerLegalName: '',
        sellerMcc: '5999',
        sellerStatus: 'ACTIVE',
        sellerStreetAddress: {
          addressLine1: '',
          addressLine2: '',
          addressLine3: '',
          cityName: '',
          countryCode: 'MX',
          postalCode: '',
          regionCode: ''
        },
        sellerUrl: ''
      },
      sellerId: '',
      sellerTransactingIndicator: true,
      significantOwner: {
        dateOfBirth: '',
        firstName: '',
        identificationNumber: '',
        lastName: '',
        streetAddress: {
          addressLine1: '',
          addressLine2: '',
          addressLine3: '',
          cityName: '',
          countryCode: 'MX',
          postalCode: '',
          regionCode: ''
        }
      },
      updatedAt: '',
    };
  }
}
